import { useEffect, useRef, useState } from "react";

const REQUEST_STATUS_BADGE_REAPPEAR_DELAY_MS = 2000;

export function useRequestStatusBadge(
    isWaitingForAgentReply: boolean,
    composerActiveOverride?: boolean,
) {
    const [isComposerActive, setIsComposerActive] = useState(false);
    const [isDelayedVisible, setIsDelayedVisible] = useState(true);
    const reappearTimeoutRef = useRef<number | null>(null);

    useEffect(function clearReappearTimeoutOnUnmount() {
        return function clearReappearTimeout() {
            if (reappearTimeoutRef.current !== null) {
                window.clearTimeout(reappearTimeoutRef.current);
            }
        };
    }, []);

    function onMessageSent() {
        setIsDelayedVisible(false);

        if (reappearTimeoutRef.current !== null) {
            window.clearTimeout(reappearTimeoutRef.current);
        }

        reappearTimeoutRef.current = window.setTimeout(() => {
            setIsDelayedVisible(true);
            reappearTimeoutRef.current = null;
        }, REQUEST_STATUS_BADGE_REAPPEAR_DELAY_MS);
    }

    const composerActive = composerActiveOverride ?? isComposerActive;

    return {
        isVisible: isWaitingForAgentReply && !composerActive && isDelayedVisible,
        onComposerActiveChange: setIsComposerActive,
        onMessageSent,
    };
}
